<template>
  <v-container fluid class="py-4 px-2 px-md-6">
    <!-- CONTENEDOR GENERAL -->
    <v-card class="pa-6 global-dashboard-card">
      <v-card-title class="text-h6 font-weight-bold d-flex align-center justify-space-between">
        <span>📊 Dashboards</span>

        <v-btn v-if="puedeAgregarDashboards" color="primary" small depressed @click="dialogAgregar = true">
          <v-icon left>mdi-plus</v-icon>
          Agregar dashboard
        </v-btn>
      </v-card-title>

      <v-divider class="mb-4"></v-divider>

      <!-- FILTROS -->
      <v-row class="mb-4">
        <v-col cols="12">
          <v-chip-group v-model="filtroSeleccionado" row mandatory show-arrows active-class="primary white--text">
            <!-- Visualizador: SOLO Dust Mapping -->
            <template v-if="esVisualizadorDashboards">
              <v-chip value="dustmapping">Todos (Dust Mapping)</v-chip>
              <v-chip v-for="c in clientesDustMapping" :key="c.key" :value="`cliente:${c.key}`">
                {{ c.label }}
              </v-chip>
            </template>

            <!-- Resto de roles -->
            <template v-else>
              <v-chip value="todos">Todos</v-chip>
              <v-chip v-if="esAdminGabinetes" value="gabinetes">Gabinetes</v-chip>
              <v-chip value="clientes">Clientes</v-chip>
              <v-chip value="dustmapping">Dust Mapping</v-chip>
              <v-chip value="proyectos">Proyectos</v-chip>
              <v-chip value="hh">Horas Hombre</v-chip>

              <v-chip value="cliente:codelco">Codelco</v-chip>
              <v-chip value="cliente:mantoverde">Mantoverde</v-chip>
              <v-chip value="cliente:elabra">El Abra</v-chip>
              <v-chip value="cliente:sqm">SQM</v-chip>
            </template>
          </v-chip-group>
        </v-col>
      </v-row>

      <!-- GABINETES ARRIBA (cuando filtro es gabinetes) -->
      <div v-if="mostrarGabinetes && filtroSeleccionado === 'gabinetes'" class="mb-6">
        <div class="d-flex align-center justify-space-between mb-2">
          <h3 class="text-subtitle-1 font-weight-bold">📦 Gabinetes</h3>
          <span class="text-caption grey--text text--darken-1">3 dashboard(s)</span>
        </div>

        <v-row>
          <v-col cols="12" md="4">
            <v-card class="mb-4 white-card">
              <v-card-title class="dashboard-header estado">📦 Estado</v-card-title>
              <v-card-text>
                <pie-chart :data="datosEstado" />
              </v-card-text>
            </v-card>
          </v-col>

          <v-col cols="12" md="4">
            <v-card class="mb-4 white-card">
              <v-card-title class="dashboard-header ubicacion">📍 Ubicación</v-card-title>
              <v-card-text>
                <pie-chart :data="datosUbicacion" />
              </v-card-text>
            </v-card>
          </v-col>

          <v-col cols="12" md="4">
            <v-card class="mb-4 white-card">
              <v-card-title class="dashboard-header proyecto">📁 Proyecto</v-card-title><v-card-text>
                <pie-chart :data="datosProyecto" />
              </v-card-text>
            </v-card>
          </v-col>
        </v-row>

        <v-divider class="mt-2"></v-divider>
      </div>

      <!-- PREVISUALIZACIONES POWER BI -->
      <div class="mb-6">
        <div v-for="section in powerBiReportsAgrupados" :key="section.key" class="mb-6">
          <div class="d-flex align-center justify-space-between mb-2">
            <h3 class="text-subtitle-1 font-weight-bold">
              {{ section.titulo }}
            </h3>

            <span class="text-caption grey--text text--darken-1">
              {{ section.items.length }} dashboard(s)
            </span>
          </div>

          <v-row>
            <v-col v-for="report in section.items" :key="report.id" cols="12" md="4">
              <v-card class="mb-4 white-card powerbi-card" outlined hover @click="irAReporte(report.id)">
                <v-card-title class="dashboard-header proyecto d-flex align-center">
                  <v-icon left>mdi-chart-box</v-icon>

                  <span class="flex-grow-1 text-truncate">
                    {{ report.titulo }}
                  </span>

                  <!-- EDITAR (izquierda) -->
                  <v-btn v-if="puedeAgregarDashboards" icon x-small color="white" class="edit-btn"
                    title="Editar dashboard" @click.stop="abrirEditarDashboard(report)">
                    <v-icon small>mdi-pencil</v-icon>
                  </v-btn>

                  <!-- ELIMINAR (derecha) -->
                  <v-btn v-if="puedeEliminarDashboards" icon x-small color="red" class="delete-btn"
                    title="Eliminar dashboard" @click.stop="confirmarEliminarDashboard(report)">
                    <v-icon small>mdi-delete</v-icon>
                  </v-btn>
                </v-card-title>

                <v-card-text>
                  <!-- PREVIEW REAL -->
                  <div class="powerbi-preview-wrapper" @click.stop>
                    <div class="powerbi-preview-embed" :class="{ 'powerbi-preview-embed--no-cut': report.workspace_id && report.workspace_id.toLowerCase() === '9f6e3fea-1a7b-403e-9226-b21766135ed2' }" :ref="`pbi_${report.id}`"></div>

                    <div class="preview-overlay" @click="irAReporte(report.id)"></div>

                    <div v-if="!embedState[report.id] || embedState[report.id].status !== 'ready'"
                      class="preview-fallback d-flex flex-column align-center justify-center">
                      <v-icon large color="primary">mdi-chart-box</v-icon>
                      <div class="text-caption mt-2 grey--text text--darken-1">
                        {{ embedState[report.id] && embedState[report.id].status === 'error'
                          ? 'No se pudo cargar preview'
                          : 'Cargando preview...' }}
                      </div>
                    </div>
                  </div>

                  <div class="mt-2 text-caption grey--text text--darken-1">
                    {{ report.descripcion }}
                  </div>
                </v-card-text>
              </v-card>
            </v-col>
          </v-row>

          <v-divider class="mt-2"></v-divider>
        </div>
      </div>

      <!-- GABINETES -->
      <div v-if="mostrarGabinetes && filtroSeleccionado !== 'gabinetes'" class="mb-6">
        <div class="d-flex align-center justify-space-between mb-2">
          <h3 class="text-subtitle-1 font-weight-bold">📦 Gabinetes</h3>
          <span class="text-caption grey--text text--darken-1">3 dashboard(s)</span>
        </div>

        <v-row>
          <v-col cols="12" md="4">
            <v-card class="mb-4 white-card">
              <v-card-title class="dashboard-header estado">📦 Estado</v-card-title>
              <v-card-text>
                <pie-chart :data="datosEstado" />
              </v-card-text>
            </v-card>
          </v-col>

          <v-col cols="12" md="4">
            <v-card class="mb-4 white-card">
              <v-card-title class="dashboard-header ubicacion">📍 Ubicación</v-card-title>
              <v-card-text>
                <pie-chart :data="datosUbicacion" />
              </v-card-text>
            </v-card>
          </v-col>

          <v-col cols="12" md="4">
            <v-card class="mb-4 white-card">
              <v-card-title class="dashboard-header proyecto">📁 Proyecto</v-card-title>
              <v-card-text>
                <pie-chart :data="datosProyecto" />
              </v-card-text>
            </v-card>
          </v-col>
        </v-row>

        <v-divider class="mt-2"></v-divider>
      </div>

      <!-- DIALOG: Agregar Dashboard (solo Admin) -->
      <v-dialog v-model="dialogAgregar" max-width="720px" persistent>
        <v-card>
          <v-card-title class="d-flex align-center justify-space-between">
            <span class="text-h6 font-weight-bold">➕ Agregar dashboard</span>
            <v-btn icon @click="dialogAgregar = false">
              <v-icon>mdi-close</v-icon>
            </v-btn>
          </v-card-title>

          <v-divider></v-divider>

          <v-card-text class="pt-4">
            <v-row>
              <v-col cols="12" md="6">
                <v-text-field v-model="nuevoDashboard.id" label="ID (único)" hint="Ej: DashboardInternoElAbra"
                  persistent-hint outlined dense />
              </v-col>

              <v-col cols="12" md="6">
                <v-select v-model="nuevoDashboard.categoria"
                  :items="['clientes', 'dustmapping', 'proyectos', 'hh', 'otros']" label="Categoría" outlined dense />
              </v-col>

              <v-col cols="12" md="6">
                <v-text-field v-model="nuevoDashboard.titulo" label="Título" outlined dense />
              </v-col>

              <v-col cols="12" md="6">
                <v-text-field v-model="nuevoDashboard.cliente" label="Cliente (opcional)"
                  hint="Ej: El Abra, SQM, Codelco..." persistent-hint outlined dense />
              </v-col>

              <v-col cols="12">
                <v-textarea v-model="nuevoDashboard.descripcion" label="Descripción" auto-grow rows="2" outlined
                  dense />
              </v-col>

              <v-col cols="12">
                <v-text-field v-model="nuevoDashboard.powerbi_link" label="Link Power BI"
                  hint="Pega un link tipo: https://app.powerbi.com/groups/<workspaceId>/reports/<reportId>/..."
                  persistent-hint outlined dense @blur="autocompletarIdsDesdeLink" />
              </v-col>

              <v-col cols="12" md="6">
                <v-text-field v-model="nuevoDashboard.workspace_id" label="Workspace ID"
                  hint="Se completa solo si pegas un link válido" persistent-hint outlined dense />
              </v-col>

              <v-col cols="12" md="6">
                <v-text-field v-model="nuevoDashboard.report_id" label="Report ID"
                  hint="Se completa solo si pegas un link válido" persistent-hint outlined dense />
              </v-col>
            </v-row>

            <v-alert type="info" dense text class="mt-2">
              El ID unico será la URL/link con el cual se podrá acceder al reporte
            </v-alert>
          </v-card-text>

          <v-divider></v-divider>

          <v-card-actions class="justify-end">
            <v-btn text @click="dialogAgregar = false">Cancelar</v-btn>
            <v-btn color="primary" @click="agregarDashboardBackend">
              Guardar
            </v-btn>
          </v-card-actions>
        </v-card>
      </v-dialog>

      <!-- DIALOG: Editar Dashboard -->
      <v-dialog v-model="dialogEditar" max-width="720px" persistent>
        <v-card>
          <v-card-title class="d-flex align-center justify-space-between">
            <span class="text-h6 font-weight-bold">✏️ Editar dashboard</span>
            <v-btn icon @click="cerrarDialogEditar">
              <v-icon>mdi-close</v-icon>
            </v-btn>
          </v-card-title>

          <v-divider></v-divider>

          <v-card-text class="pt-4">
            <v-row>
              <v-col cols="12" md="6">
                <!-- ID bloqueado: es la llave -->
                <v-text-field v-model="editarDashboard.id" label="ID (único)" outlined dense disabled />
              </v-col>

              <v-col cols="12" md="6">
                <v-select v-model="editarDashboard.categoria"
                  :items="['clientes', 'dustmapping', 'proyectos', 'hh', 'otros']" label="Categoría" outlined dense />
              </v-col>

              <v-col cols="12" md="6">
                <v-text-field v-model="editarDashboard.titulo" label="Título" outlined dense />
              </v-col>

              <v-col cols="12" md="6">
                <v-text-field v-model="editarDashboard.cliente" label="Cliente (opcional)"
                  hint="Ej: El Abra, SQM, Codelco..." persistent-hint outlined dense />
              </v-col>

              <v-col cols="12">
                <v-textarea v-model="editarDashboard.descripcion" label="Descripción" auto-grow rows="2" outlined
                  dense />
              </v-col>

              <v-col cols="12">
                <v-text-field v-model="editarDashboard.powerbi_link" label="Link Power BI"
                  hint="https://app.powerbi.com/groups/<workspaceId>/reports/<reportId>/..." persistent-hint outlined
                  dense @blur="autocompletarIdsDesdeLinkEditar" />
              </v-col>

              <v-col cols="12" md="6">
                <v-text-field v-model="editarDashboard.workspace_id" label="Workspace ID" outlined dense />
              </v-col>

              <v-col cols="12" md="6">
                <v-text-field v-model="editarDashboard.report_id" label="Report ID" outlined dense />
              </v-col>
            </v-row>

            <v-alert type="info" dense text class="mt-2">
              Puedes pegar un link nuevo para autocompletar Workspace ID y Report ID.
            </v-alert>
          </v-card-text>

          <v-divider></v-divider>

          <v-card-actions class="justify-end">
            <v-btn text @click="cerrarDialogEditar">Cancelar</v-btn>
            <v-btn color="primary" :loading="editando" @click="guardarEdicionDashboard">
              Guardar cambios
            </v-btn>
          </v-card-actions>
        </v-card>
      </v-dialog>

      <!-- DIALOG: Confirmar eliminación -->
      <v-dialog v-model="dialogEliminar" max-width="520px">
        <v-card>
          <v-card-title class="d-flex align-center justify-space-between">
            <div class="d-flex align-center">
              <v-icon color="red" class="mr-2">mdi-alert</v-icon>
              <span class="text-h6 font-weight-bold">Eliminar dashboard</span>
            </div>

            <v-btn icon @click="dialogEliminar = false" :disabled="eliminando">
              <v-icon>mdi-close</v-icon>
            </v-btn>
          </v-card-title>

          <v-divider />

          <v-card-text class="pt-4">
            <div class="text-body-1">
              ¿Seguro que deseas eliminar este dashboard?
            </div>

            <v-alert type="warning" text dense class="mt-3">
              Esta acción <b>no se puede deshacer</b>.
            </v-alert>

            <div class="mt-3">
              <div class="text-subtitle-2 font-weight-bold">
                {{ dashboardAEliminar && dashboardAEliminar.titulo }}
              </div>
              <div class="text-caption grey--text text--darken-1">
                ID: {{ dashboardAEliminar && dashboardAEliminar.id }}
              </div>
            </div>
          </v-card-text>

          <v-divider />

          <v-card-actions class="justify-end">
            <v-btn text @click="dialogEliminar = false" :disabled="eliminando">
              Cancelar
            </v-btn>

            <v-btn color="red" dark @click="eliminarDashboardConfirmado" :loading="eliminando">
              <v-icon left>mdi-delete</v-icon>
              Eliminar
            </v-btn>
          </v-card-actions>
        </v-card>
      </v-dialog>

      <!--SNACKBAR EXITO/ERROR MODIFICACION-->
      <v-snackbar v-model="snackbar.show" :color="snackbar.color" :timeout="snackbar.timeout" top right>
        <v-icon left v-if="snackbar.icon">{{ snackbar.icon }}</v-icon>
        {{ snackbar.text }}

        <template v-slot:action="{ attrs }">
          <v-btn text v-bind="attrs" @click="snackbar.show = false">
            Cerrar
          </v-btn>
        </template>
      </v-snackbar>
      <!-- BOTÓN VOLVER -->
      <v-row class="justify-end mt-4">
        <v-col cols="auto">
          <v-btn color="grey darken-3" block class="mt-2" @click="volverInicio">
            <v-icon left>mdi-home</v-icon> Volver a Inicio
          </v-btn>
        </v-col>
      </v-row>
    </v-card>
  </v-container>
</template>

<script>
import axios from "axios";
import API_BASE from "@/helpers/api";
import PieChart from "@/components/PieChart.vue";
import { models, service, factories } from "powerbi-client";

export default {
  name: "DashboardsView",
  components: {
    PieChart,
  },
  data() {
    return {
      usuario: JSON.parse(sessionStorage.getItem("usuario")),
      datosEstado: [],
      datosUbicacion: [],
      datosProyecto: [],
      filtroSeleccionado: "todos",
      powerBiReports: [],
      dialogAgregar: false,

      dialogEliminar: false,
      dashboardAEliminar: null,
      eliminando: false,
      //editardashboard
      dialogEditar: false,
      editando: false,
      editarDashboard: {
        id: "",
        titulo: "",
        descripcion: "",
        categoria: "",
        cliente: "",
        powerbi_link: "",
        workspace_id: "",
        report_id: "",
      },
      snackbar: {
        show: false,
        text: "",
        color: "success", // success | error | warning | info
        icon: "mdi-check-circle",
        timeout: 3000,
      },
      // Power BI preview
      embedState: {},
      embedCache: {},
      embeddedInstances: {},
      powerbiService: null,
      previewLimit: 9,
      previewRefreshKey: 0,

      nuevoDashboard: {
        id: "",
        titulo: "",
        descripcion: "",
        categoria: "",
        cliente: "",
        powerbi_link: "",
        workspace_id: "",
        report_id: "",
      },
    };
  },

  async mounted() {
    // init powerbi service (SIN try/catch vacío)
    this.powerbiService = this.initPowerBiService();

    await this.cargarDashboards();

    if (this.esVisualizadorDashboards) {
      this.filtroSeleccionado = "dustmapping";
    }

    if (this.esAdminGabinetes && this.obtenerDatosGabinetes) {
      this.obtenerDatosGabinetes();
    }

    this.$nextTick(() => {
      this.renderPreviews();
    });
  },

  beforeDestroy() {
    // limpiar listeners sin try/catch vacío
    Object.keys(this.embeddedInstances || {}).forEach((id) => {
      const inst = this.embeddedInstances[id];
      if (inst && typeof inst.off === "function") {
        inst.off("loaded");
        inst.off("error");
      }
    });
    this.embeddedInstances = {};
  },

  computed: {
    esAdminTI() {
      return (this.usuario && this.usuario.rol ? this.usuario.rol : "").toLowerCase() === "adminti";
    },
    puedeAgregarDashboards() {
      return this.esAdmin || this.esAdminTI;
    },
    esAdmin() {
      return (this.usuario && this.usuario.rol ? this.usuario.rol : "").toLowerCase() === "admin";
    },
    esAdminSIST() {
      return (this.usuario && this.usuario.rol ? this.usuario.rol : "").toLowerCase() === "adminsist";
    },
    esAdminGabinetes() {
      return this.esAdmin || this.esAdminSIST;
    },
    clientesDustMapping() {
      const reports = (this.powerBiReports || []).filter(
        (r) => (r.categoria || "").toLowerCase() === "dustmapping" && r.cliente
      );

      const map = new Map();
      for (let i = 0; i < reports.length; i++) {
        const r = reports[i];
        const label = (r.cliente || "").trim();
        const key = this.normalizarKey(label);
        if (!map.has(key)) map.set(key, { key, label });
      }

      return Array.from(map.values()).sort((a, b) =>
        a.label.localeCompare(b.label, "es")
      );
    },
    esVisualizadorDashboards() {
      return (this.usuario && this.usuario.rol ? this.usuario.rol : "").toLowerCase() === "visualizador";
    },
    mostrarGabinetes() {
      return (
        this.esAdminGabinetes &&
        (this.filtroSeleccionado === "todos" || this.filtroSeleccionado === "gabinetes")
      );
    },
    categoriasConfig() {
      return [
        { key: "gabinetes", titulo: "📦 Gabinetes" },
        { key: "clientes", titulo: "🏷 Clientes" },
        { key: "dustmapping", titulo: "🌫 Dust Mapping" },
        { key: "proyectos", titulo: "📁 Proyectos" },
        { key: "hh", titulo: "⏱ Horas Hombre" },
        { key: "otros", titulo: "📌 Otros" },
      ];
    },
    powerBiReportsAgrupados() {
      let reportsVisibles = this.esVisualizadorDashboards
        ? (this.powerBiReports || []).filter(r => (r.categoria || "").toLowerCase() === "dustmapping")
        : (this.powerBiReports || []);

      const filtro = this.filtroSeleccionado || "todos";
      if (typeof filtro === "string" && filtro.indexOf("cliente:") === 0) {
        const clienteKey = filtro.split(":")[1];
        const clienteKeyNorm = this.normalizarKey(clienteKey);

        reportsVisibles = reportsVisibles.filter(r => {
          const reportClienteNorm = this.normalizarKey(r.cliente);
          return reportClienteNorm === clienteKeyNorm;
        });
      }

      const grupos = reportsVisibles.reduce((acc, r) => {
        const cat = r.categoria || "otros";
        if (!acc[cat]) acc[cat] = [];
        acc[cat].push(r);
        return acc;
      }, {});

      if (this.esVisualizadorDashboards) {
        const dm = grupos["dustmapping"] || [];
        return dm.length ? [{ key: "dustmapping", titulo: "🌫 Dust Mapping", items: dm }] : [];
      }

      let orden = [].concat(this.categoriasConfig);

      if (filtro && filtro !== "todos" && String(filtro).indexOf("cliente:") !== 0) {
        orden = []
          .concat(orden.filter((c) => c.key === filtro))
          .concat(orden.filter((c) => c.key !== filtro));
      }

      return orden
        .filter((c) => c.key !== "gabinetes")
        .map((c) => ({
          key: c.key,
          titulo: c.titulo,
          items: grupos[c.key] || [],
        }))
        .filter((section) => section.items.length > 0);
    },
    powerBiVisibleFlat() {
      const sections = this.powerBiReportsAgrupados || [];
      return sections.reduce((acc, s) => acc.concat(s.items || []), []);
    },
    puedeEliminarDashboards() {
      const rol = (this.usuario && this.usuario.rol ? this.usuario.rol : "").toString().trim().toLowerCase();
      return ["admin", "adminti", "adminsist"].includes(rol);
    },
  },

  methods: {
    // helper sin catch vacío
    safe(fn, fallback) {
      try {
        return fn();
      } catch (err) {
        return fallback;
      }
    },

    initPowerBiService() {
      return this.safe(() => {
        return new service.Service(
          factories.hpmFactory,
          factories.wpmpFactory,
          factories.routerFactory
        );
      }, null);
    },
    showSnackbar({ text, color = "success", icon, timeout }) {
      this.snackbar.text = text || "";
      this.snackbar.color = color || "success";
      this.snackbar.icon =
        icon ||
        (color === "success"
          ? "mdi-check-circle"
          : color === "error"
            ? "mdi-alert-circle"
            : color === "warning"
              ? "mdi-alert"
              : "mdi-information");

      this.snackbar.timeout = typeof timeout === "number" ? timeout : 3000;
      this.snackbar.show = true;
    },
    async cargarDashboards() {
      try {
        const { data } = await axios.get(`${API_BASE}/dashboard/powerbi`);

        this.powerBiReports = (data || []).map(d => ({
          id: d.id,
          titulo: d.titulo,
          descripcion: d.descripcion,
          categoria: d.categoria,
          cliente: d.cliente,
          workspace_id: d.workspace_id,
          report_id: d.report_id,
        }));

        this.$nextTick(() => {
          this.renderPreviews();
        });
      } catch (err) {
        console.error("Error cargando dashboards:", err);
      }
    },

    async renderPreviews() {
      if (!this.powerbiService) return;

      const visibles = (this.powerBiVisibleFlat || []).slice(0, this.previewLimit);

      for (let i = 0; i < visibles.length; i++) {
        const r = visibles[i];

        // si ya está listo, no rehagas
        if (this.embedState[r.id] && this.embedState[r.id].status === "ready") continue;

        if (!r.report_id || !r.workspace_id) {
          this.$set(this.embedState, r.id, { status: "error", error: "Falta workspace_id/report_id" });
          continue;
        }

        const refKey = `pbi_${r.id}`;

        // ⚠️ Vue2: ref en v-for => array
        const raw = this.$refs[refKey];
        const container = Array.isArray(raw) ? raw[0] : raw;

        if (!container) continue;

        this.$set(this.embedState, r.id, { status: "loading" });

        try {
          const { data } = await axios.get(
            `${API_BASE}/dashboard/embed/${encodeURIComponent(r.id)}`,
            {
              headers: { "x-user-role": this.usuario ? this.usuario.rol : "" },
            }
          );

          this.$set(this.embedCache, r.id, {
            embedUrl: data.embedUrl,
            accessToken: data.embedToken,
            reportId: data.reportId || r.report_id,
          });

          // reset previo
          try {
            this.powerbiService.reset(container);
          } catch (resetErr) {
            console.warn("powerbiService.reset falló:", resetErr);
          }

          const config = {
            type: "report",
            tokenType: models.TokenType.Embed,
            accessToken: data.embedToken,
            embedUrl: data.embedUrl,
            id: data.reportId || r.report_id,
            permissions: models.Permissions.Read,
            settings: {
              panes: {
                filters: { visible: false },
                pageNavigation: { visible: false },
              },
              background: models.BackgroundType.Transparent,
              navContentPaneEnabled: false,
            },
          };

          const report = this.powerbiService.embed(container, config);

          this.$set(this.embeddedInstances, r.id, report);

          // limpiar handlers anteriores
          if (report && typeof report.off === "function") {
            report.off("loaded");
            report.off("error");
          }

          if (report && typeof report.on === "function") {
            report.on("loaded", () => {
              this.$set(this.embedState, r.id, { status: "ready" });
            });

            report.on("error", (event) => {
              const msg =
                event && event.detail && event.detail.message
                  ? event.detail.message
                  : "Error embed";

              console.error("PowerBI preview error:", r.id, msg);
              this.$set(this.embedState, r.id, { status: "error", error: msg });
            });
          }
        } catch (err) {
          const msg =
            err && err.response && err.response.data
              ? JSON.stringify(err.response.data)
              : (err && err.message ? err.message : "Error");

          console.error("Error cargando preview:", r.id, msg);

          this.$set(this.embedState, r.id, {
            status: "error",
            error:
              (err && err.response && err.response.data && err.response.data.message)
                ? err.response.data.message
                : (err && err.message ? err.message : "Error"),
          });
        }
      }
    },

    refreshPreviews() {
      this.previewRefreshKey++;
      this.$nextTick(() => this.renderPreviews());
    },

    async agregarDashboardBackend() {
      this.autocompletarIdsDesdeLink();

      const payload = {
        id: (this.nuevoDashboard.id || "").trim(),
        titulo: (this.nuevoDashboard.titulo || "").trim(),
        descripcion: (this.nuevoDashboard.descripcion || "").trim() || null,
        categoria: (this.nuevoDashboard.categoria || "").trim(),
        cliente: (this.nuevoDashboard.cliente || "").trim() || null,
        workspace_id: (this.nuevoDashboard.workspace_id || "").trim() || null,
        report_id: (this.nuevoDashboard.report_id || "").trim() || null,
      };

      if (!payload.id || !payload.titulo || !payload.categoria) {
        alert("Faltan campos obligatorios: ID, Título y Categoría.");
        return;
      }

      if (!payload.workspace_id || !payload.report_id) {
        alert("Faltan Workspace ID y Report ID. Pega un link válido de Power BI para autocompletar.");
        return;
      }

      const uuidRe = /^[0-9a-f]{8}-[0-9a-f]{4}-[1-5][0-9a-f]{3}-[89ab][0-9a-f]{3}-[0-9a-f]{12}$/i;
      if (!uuidRe.test(payload.workspace_id) || !uuidRe.test(payload.report_id)) {
        alert("Workspace ID o Report ID no tienen formato UUID válido.");
        return;
      }

      try {
        await axios.post(`${API_BASE}/dashboard/powerbi`, payload, {
          headers: { "x-user-role": this.usuario ? this.usuario.rol : "" },
        });

        await this.cargarDashboards();

        this.nuevoDashboard = {
          id: "",
          titulo: "",
          descripcion: "",
          categoria: "",
          cliente: "",
          powerbi_link: "",
          workspace_id: "",
          report_id: "",
        };

        this.dialogAgregar = false;
      } catch (err) {
        console.error("Error guardando dashboard:", (err && err.response && err.response.data) ? err.response.data : err.message);
        alert((err && err.response && err.response.data && err.response.data.message) ? err.response.data.message : "No se pudo guardar el dashboard.");
      }
    },
    abrirEditarDashboard(report) {
      // rellenar formulario con lo actual
      this.editarDashboard = {
        id: report.id,
        titulo: report.titulo || "",
        descripcion: report.descripcion || "",
        categoria: report.categoria || "otros",
        cliente: report.cliente || "",
        powerbi_link: "", // opcional (si no guardas el link)
        workspace_id: report.workspace_id || "",
        report_id: report.report_id || "",
      };

      this.dialogEditar = true;
    },

    cerrarDialogEditar() {
      this.dialogEditar = false;
      this.editando = false;
    },

    autocompletarIdsDesdeLinkEditar() {
      const link = (this.editarDashboard.powerbi_link || "").trim();
      if (!link) return;

      const ids = this.extraerWorkspaceYReportId(link);
      if (!ids) return;

      this.editarDashboard.workspace_id = ids.workspace_id;
      this.editarDashboard.report_id = ids.report_id;
    },

    async guardarEdicionDashboard() {
      const payload = {
        titulo: this.editarDashboard.titulo.trim(),
        descripcion: this.editarDashboard.descripcion?.trim() || null,
        categoria: this.editarDashboard.categoria.trim(),
        cliente: this.editarDashboard.cliente?.trim() || null,
        workspace_id: this.editarDashboard.workspace_id.trim(),
        report_id: this.editarDashboard.report_id.trim(),
      };

      this.editando = true;

      try {
        const { data } = await axios.put(
          `${API_BASE}/dashboard/powerbi/${encodeURIComponent(this.editarDashboard.id)}`,
          payload,
          { headers: { "x-user-role": this.usuario?.rol || "" } }
        );

        // ✅ SNACKBAR ÉXITO
        this.showSnackbar({
          text: data?.message || "Dashboard actualizado correctamente",
          color: "success",
          icon: "mdi-check-circle",
        });

        this.dialogEditar = false;

        await this.cargarDashboards();

        // refrescar previews
        this.embedState = {};
        this.embedCache = {};
        this.embeddedInstances = {};
        this.$nextTick(() => this.renderPreviews());

      } catch (err) {
        console.error("Error editando dashboard:", err);

        // ❌ SNACKBAR ERROR
        this.showSnackbar({
          text: err?.response?.data?.message || "No se pudo actualizar el dashboard",
          color: "error",
          icon: "mdi-alert-circle",
        });
      } finally {
        this.editando = false;
      }
    },

    normalizarKey(txt) {
      return (txt || "")
        .toString()
        .trim()
        .toLowerCase()
        .normalize("NFD").replace(/[\u0300-\u036f]/g, "")
        .replace(/[^a-z0-9]+/g, "");
    },

    autocompletarIdsDesdeLink() {
      const link = (this.nuevoDashboard.powerbi_link || "").trim();
      if (!link) return;

      const ids = this.extraerWorkspaceYReportId(link);
      if (!ids) return;

      this.nuevoDashboard.workspace_id = ids.workspace_id;
      this.nuevoDashboard.report_id = ids.report_id;
    },

    extraerWorkspaceYReportId(url) {
      return this.safe(() => {
        const u = new URL(url);
        const path = u.pathname || "";

        const m = path.match(/\/groups\/([^/]+)\/reports\/([^/]+)/i);
        if (m && m[1] && m[2]) {
          const workspace_id = String(m[1]).toLowerCase();
          const report_id = String(m[2]).toLowerCase();
          if (workspace_id === "me") return null;
          return { workspace_id, report_id };
        }

        return null;
      }, null);
    },

    volverInicio() {
      this.$router.push("/inicio");
    },

    irAReporte(reportId) {
      const routeData = this.$router.resolve({
        path: `/dashboards/${reportId}`,
      });
      window.open(routeData.href, "_blank", "noopener,noreferrer");
    },

    extraerTokenDeUrl(url) {
      return this.safe(() => {
        const u = new URL(url);
        return (u.searchParams.get("r") || "").trim();
      }, "");
    },

    agregarDashboardLocal() {
      if (!this.nuevoDashboard.id || !this.nuevoDashboard.titulo || !this.nuevoDashboard.categoria || !this.nuevoDashboard.url) {
        alert("Faltan campos obligatorios: ID, Título, Categoría y URL.");
        return;
      }

      const token = this.extraerTokenDeUrl(this.nuevoDashboard.url);
      if (!token) {
        alert("No pude detectar el token 'r=' desde la URL. Asegúrate que sea un link tipo: https://app.powerbi.com/view?r=...");
        return;
      }

      const existe = (this.powerBiReports || []).some(r => r.id === this.nuevoDashboard.id);
      if (existe) {
        alert("Ya existe un dashboard con ese ID.");
        return;
      }

      const nuevo = this.normalizarDashboards([{
        id: this.nuevoDashboard.id.trim(),
        titulo: this.nuevoDashboard.titulo.trim(),
        descripcion: (this.nuevoDashboard.descripcion || "").trim(),
        categoria: this.nuevoDashboard.categoria.trim(),
        cliente: (this.nuevoDashboard.cliente || "").trim() || undefined,
        pbiToken: token,
      }])[0];

      this.powerBiReports = [].concat(this.powerBiReports, [nuevo]);

      this.nuevoDashboard = { id: "", titulo: "", descripcion: "", categoria: "", cliente: "", url: "" };
      this.dialogAgregar = false;
    },

    async eliminarDashboardConfirmado() {
      if (!this.dashboardAEliminar || !this.dashboardAEliminar.id) return;

      this.eliminando = true;

      try {
        const id = this.dashboardAEliminar.id;

        await axios.delete(`${API_BASE}/dashboard/powerbi/${encodeURIComponent(id)}`, {
          headers: { "x-user-role": this.usuario ? this.usuario.rol : "" },
        });

        this.dialogEliminar = false;
        this.dashboardAEliminar = null;

        await this.cargarDashboards();
      } catch (err) {
        console.error("Error eliminando dashboard:", (err && err.response && err.response.data) ? err.response.data : err.message);
        alert((err && err.response && err.response.data && err.response.data.message) ? err.response.data.message : "No se pudo eliminar el dashboard.");
      } finally {
        this.eliminando = false;
      }
    },

    confirmarEliminarDashboard(report) {
      if (!this.puedeEliminarDashboards) return;

      this.dashboardAEliminar = report;
      this.dialogEliminar = true;
    },
  },

  watch: {
    filtroSeleccionado(val) {
      if (this.esVisualizadorDashboards) {
        const esCliente = typeof val === "string" && val.indexOf("cliente:") === 0;
        if (val !== "dustmapping" && !esCliente) {
          this.filtroSeleccionado = "dustmapping";
        }
      }

      if (val === "gabinetes" && !this.esAdminGabinetes) {
        this.filtroSeleccionado = "todos";
      }

      if (val === "ti" && !this.esAdminTI) {
        this.filtroSeleccionado = "todos";
      }

      this.refreshPreviews();
    },
  },
};
</script>

<style scoped>
.white-card {
  background-color: #ffffff !important;
  color: #0293d3 !important;
  border-radius: 12px;
  box-shadow: 0 2px 8px rgba(0, 0, 0, 0.1);
}

.dashboard-header {
  font-weight: bold;
  color: #ffffff !important;
}

/* Estado / Ubicación / Proyecto */
.dashboard-header.estado,
.dashboard-header.ubicacion,
.dashboard-header.proyecto,
.dashboard-header.colaboradores,
.dashboard-header.perifericos,
.dashboard-header.equipos {
  background-color: #0293d3 !important;
}

.global-dashboard-card {
  background-color: #ffffff;
  border-radius: 16px;
  box-shadow: 0 4px 20px rgba(0, 0, 0, 0.2);
}

/* Cartas modo claro/oscuro */
.theme--light .white-card {
  background-color: #ffffff !important;
  color: #27282a !important;
}

.theme--dark .white-card {
  background-color: #0303031e !important;
  color: #ffffff !important;
}

.theme--light .global-dashboard-card {
  background-color: #ffffff;
  color: #27282a;
}

.theme--dark .global-dashboard-card {
  background-color: #27282a;
  color: #ffffff;
}

/*edicion*/
.edit-btn {
  opacity: 0.75;
  margin-left: 6px;
}

.edit-btn:hover {
  opacity: 1;
}

/* Estilos específicos para Power BI preview */
.powerbi-card {
  cursor: pointer;
  transition: transform 0.15s ease, box-shadow 0.15s ease;
}

.powerbi-card:hover {
  transform: translateY(-2px);
  box-shadow: 0 6px 16px rgba(0, 0, 0, 0.18);
}

.powerbi-preview-wrapper {
  width: 100%;
  height: 220px;
  border-radius: 10px;
  overflow: hidden;
  background: #f5f5f5;
  position: relative;
}

.powerbi-preview-embed {
  position: absolute;
  inset: 0;

  /* BARRA VERSIÓN DE PRUEBA GRATUITA CORTADA” */
  top: -46px;
  height: calc(100% + 46px);
  width: 100%;
}

.powerbi-preview-embed--no-cut {
  top: 0;
  height: 100%;
}

/* embed es iframe directo dentro de .powerbi-preview-embed */
.powerbi-preview-embed iframe {
  width: 100%;
  height: 100%;
  border: 0;
  display: block;
  background: #fff;
}

.preview-overlay {
  position: absolute;
  inset: 0;
  z-index: 3;
  background: transparent;
}

.preview-fallback {
  position: absolute;
  inset: 0;
  z-index: 2;
  background: #f5f5f5;
}

/*borrar*/
.delete-btn {
  opacity: 0.75;
  margin-left: 6px;
}

.delete-btn:hover {
  opacity: 1;
}
</style>